import { CardMedia } from "@mui/material";
import { useEffect, useState } from "react";
import { getImageUrl } from "utils/imageUtils";

export interface AsyncCardMediaProps {
    url: Promise<string>;
    props?: any;
}

export const AsyncCardMedia = (props: AsyncCardMediaProps) => {
    const [url, setUrl] = useState('');

    useEffect(() => {
        const getUrl = async () => {
            setUrl(await props.url);
        }

        getUrl();
    }, [url]);

    return <CardMedia
        {...props} style={{ display: 'flex', justifyContent: 'center', objectFit: "contain" }}
        image={url == '' ? '' : getImageUrl(url)}
    />;
}